import { RotateCcwIcon, SlidersHorizontalIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

import { SandboxEntityType } from "../../types/entities";
import { InteractionType, WeightConfig } from "../../types/interactions";
import WeightTable from "./WeightTable";

interface InteractionWeightEditorProps {
  weights: WeightConfig;
  onUpdate: (
    entityType: SandboxEntityType,
    interactionType: InteractionType,
    value: number,
  ) => void;
  onReset: () => void;
}

const InteractionWeightEditor = ({
  weights,
  onUpdate,
  onReset,
}: InteractionWeightEditorProps) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          <SlidersHorizontalIcon className="mr-1.5 h-3.5 w-3.5" />
          Signal weights
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Signal weights</DialogTitle>
          <DialogDescription>
            Configure how much each type of interaction influences the taste
            profile. Weights apply globally to all personas.
          </DialogDescription>
        </DialogHeader>
        <WeightTable weights={weights} onUpdate={onUpdate} />
        <div className="flex justify-end pt-2">
          <Button variant="outline" size="sm" onClick={onReset}>
            <RotateCcwIcon className="mr-1.5 h-3.5 w-3.5" />
            Reset to defaults
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default InteractionWeightEditor;
